<template>
  <div>
    <b-form-file
      ref="fileUploadRef"
      v-model="file"
      placeholder="Choose a file or drop it here..."
      drop-placeholder="Drop file here..."
      :style="{display:'none'}"
    ></b-form-file>
    <div class="file-upload-template" v-if="template === 'image'">
      <b-button id="uploadButton" :pill="pillStyleUploadButton?true:false" :size="uploadButtonSize" :variant="uploadButtonVariant" @click="chooseFile" :disabled="disabled">Upload Image</b-button>
    </div>
    <div class="file-upload-template" v-if="template === 'document'">
      <div
        class="file-upload"
        v-for="file in files"
        :style="{
        'background-image': `url(${file.preview})`
        }"
      > 
        <div class="hover-message">
          <b-button variant="primary" size="xs" @click="goToUrl(file.preview)">
            <font-awesome-icon :icon="icon" />
            <br />
          </b-button>
          <b-button
                size="xs"
                :style="{
                   border: 'none',
                  'box-shadow': 'none',
                  'margin-left':'5px'
                }"
                v-if="isEditable"
                @click="removeUpload()"
              >
                <font-awesome-icon icon="times" />
      </b-button>
          <b-button variant="outline-primary" size="sm" v-if="false">Set as default</b-button>
        </div>
      </div>
      <div class="file-upload" @click="chooseFile" v-if="files.length == 0||isUploadAllow">
        <font-awesome-icon icon="plus" />
        <br />
      </div>
    </div>
    <b-modal ref="cropModal" title="Save Image" no-close-on-backdrop>
      <div :style="{'max-width': '100%'}">
        <img
          :src="this.files[0].preview"
          ref="imageToCrop"
          v-if="files.length > 0"
          :style="{'width': '100%'}"
        />
      </div>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="danger" @click="cancel()">Close</b-button>
        <!-- Button with custom close trigger value -->
        <b-button size="sm" variant="outline-secondary" @click="saveImage">Save</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import VueUploadComponent from "vue-upload-component";
import { FileUploadService } from "v-file-upload";
import Cropper from "cropperjs";

export default {
  name: "fileUploadTemplate",
  components: {
    // 'file-upload': VueUploadComponent,
    // 'file-upload': FileUploadService
  },
  props: {
    selectCallback: Function,
    fileKey: String,
    template: String,
    crop: Boolean,
    preview: String,
    previewType: String,
    reset:Boolean,
    pillStyleUploadButton:Boolean,
    disabled:Boolean,
    loading: Boolean,
    isEditable:Boolean,
    removeUploadCallback: Function
  },
  computed: {},
  watch: {
    file(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener(
        "load",
        () => {
          file.preview = reader.result;
          this.files = [];
          this.files.push(file);
          if (typeof this.crop !== "undefined" && this.crop == true) {
            this.$refs["cropModal"].show();
            setTimeout(() => {
              let cropper = new Cropper(this.$refs.imageToCrop, {
                aspectRatio: 1 / 1,
                viewMode: 1,
                zoomable: false
              });
              this.cropper = cropper;
            }, 100);
          } else {
            this.$emit("selected", this.fileKey, this.files);
            if(typeof this.selectCallback === 'function') this.selectCallback(this.fileKey, this.files);
          }
        },
        false
      );
    },
    loading(value) {
      console.log('loading', value);
      this.uploading =  value;
    }
  },
  data() {
    return {
      icon: "cloud-upload-alt",
      actionText: "Upload file",
      files: [],
      file: null,
      cropEvent: {},
      uploadButtonSize:"sm",
      uploadButtonVariant:"primary",
      uploading: false,
      isUploadAllow:false
    };
  },
  created() {
    if(typeof this.reset !== 'undefined') {
      console.log(this.reset);
    }
    this.files = [];
    if (typeof this.preview !== "undefined" && this.preview !== "") {
      this.files.push({
        preview: this.preview
      });
    }

    if (this.template === "image") {
      this.icon = "camera";
      this.actionText = "Upload new image.";
    }
    if (this.template === "document") {
      this.icon = "file-alt";
      this.actionText = "Upload new document.";
    }

    if (typeof this.previewType !== "undefined" && this.previewType !== "") {
      if (
        ["image/png", "image/jpg", "image/jpeg"].indexOf(this.previewType) != -1
      ) {
        this.icon = "camera";
        this.actionText = "Upload new image.";
      }
      if (["application/pdf"].indexOf(this.previewType) != -1) {
        this.icon = "file-alt";
        this.actionText = "Upload new document.";
      }
    }
    if(typeof this.isEditable==="undefined"){
      this.isEditable=false;
    }
  },
  mounted(){
    if(this.pillStyleUploadButton){
      this.uploadButtonSize="xs";
      this.uploadButtonVariant="outline-secondary";
    }
  },
  methods: {
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.xhr) {
          //  Get the response status code
        }
      }
      if (typeof this.crop !== "undefined" && this.crop == true) {
        this.$refs["cropModal"].show();
      } else {
        this.$emit("selected", this.fileKey, this.files);
        if(typeof this.selectCallback === 'function') this.selectCallback(this.fileKey, this.files);
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    thumbUrl(file) {
      // return file.myThumbUrlProperty
    },
    saveImage() {
      this.checkLoading(true);
      this.$emit("selected", this.fileKey, this.files, this.cropper.getData());
      if(typeof this.selectCallback === 'function') this.selectCallback(this.fileKey, this.files, this.cropper.getData());
      this.$refs["cropModal"].hide();
    },
    onFileChange(file) {
      // Handle files like:
      this.fileUploaded = file;
    },
    chooseFile() {
      this.$refs.fileUploadRef.$el.children[0].click();
      this.isUploadAllow=false;
    },
    goToUrl(url) {
      var win = window.open(url, "_blank");
      win.focus();
    },
    checkLoading(value) {
      console.log('this.loading', this.loading);
      if(this.loading) {
        this.uploading =  value;
      }
    },
    removeUpload(){
    this.isUploadAllow=true;
    this.files.pop();
    if(typeof this.removeUploadCallback === 'function') this.removeUploadCallback(this.fileKey);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.file-upload {
  margin: 0 5px 0 0;
  color: #d8d8d8;
  font-size: 34px;
  float: left;
  line-height: 120px !important;
  text-align: center;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  width: 120px;
  height: 120px;
  background-size: cover;
  &:hover {
    line-height: inherit;
    .hover-message {
      display: block;
    }
  }
  .file-uploads {
    cursor: pointer;
    font-size: 15px;
  }
  .hover-message {
    display: none;
  }
}
</style>